<article class="wellness-coverage">
	<button
		mat-dialog-close
		class="wellness-coverage__dismiss"
	>
		<epi-icon
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
	>
		Wellness Rewards**
	</epi-heading>
	<p class="wellness-coverage__copy u-margin-block-small">
		Embrace's Wellness Rewards is our flexible preventative care plan which reimburses you for the everyday
		veterinary,
		training, and grooming costs that keep your pet happy and healthy. Wellness Rewards is not an insurance policy,
		but
		works as a budgeting tool and rewards you for being proactive with your pet's care. Your full Wellness Rewards
		amount is available for use the day of signup.
	</p>
	<p
		id="coveredItems"
		class="wellness-coverage__list-heading"
	>
		Covered Items
	</p>
	<epi-list
		layout="wide"
		marker-color="secondary"
		class="wellness-coverage__list"
	>
		<epi-list-item>
			Routine veterinary visits
		</epi-list-item>
		<epi-list-item>
			Grooming
		</epi-list-item>
		<epi-list-item>
			Flea, tick, & heartworm meds
		</epi-list-item>
		<epi-list-item>
			Fecal & routine blood tests
		</epi-list-item>
		<epi-list-item>
			Microchipping
		</epi-list-item>
		<epi-list-item>
			Medicated shampoos
		</epi-list-item>
		<epi-list-item>
			Spay/neuter surgery
		</epi-list-item>
		<epi-list-item>
			Routine chiropractic care
		</epi-list-item>
		<epi-list-item>
			Massage & acupuncture
		</epi-list-item>
		<epi-list-item>
			Teeth cleaning
		</epi-list-item>
		<epi-list-item>
			Prescription diet food
		</epi-list-item>
		<epi-list-item>
			Training classes
		</epi-list-item>
		<epi-list-item>
			Vaccinations
		</epi-list-item>
		<epi-list-item>
			Toe nail trimming
		</epi-list-item>
		<epi-list-item>
			Anal gland expression
		</epi-list-item>
		<epi-list-item>
			Pet activity monitors
		</epi-list-item>
		<epi-list-item>
			Cremation or burial
		</epi-list-item>
		<epi-list-item>
			& much more
		</epi-list-item>
	</epi-list>
	<p class="wellness-coverage__copy u-margin-block-small">
		<strong class="wellness-coverage__tip">PRO TIP:</strong> Puppies and kittens usually require more vet visits their
		first year, so $650 is a solid
		option for new pet parents. An older pet who only needs updated vaccines and preventatives may need less coverage.
	</p>
</article>